import { Component, OnInit, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  AbstractDialog,
  AbstractDialogData,
  AbstractDialogResultData,
  DialogComponent,
} from '@next/core-lib/dialog';

import { CowDetailsComponent } from '../cow-details/cow-details.component';

export interface CowDetailsDialogInputData extends AbstractDialogData {
  internationalCowId: string;
}

@Component({
  selector: 'app-cow-details-dialog',
  templateUrl: './cow-details-dialog.component.html',
  styleUrls: ['./cow-details-dialog.component.scss'],
  imports: [DialogComponent, CowDetailsComponent],
})
export class CowDetailsDialogComponent extends AbstractDialog implements OnInit {
  protected mdDialogRef =
    inject<MatDialogRef<AbstractDialog, AbstractDialogResultData>>(MatDialogRef);
  data = inject<CowDetailsDialogInputData>(MAT_DIALOG_DATA);

  public internationalCowId: string;

  ngOnInit(): void {
    this.internationalCowId = this.data.internationalCowId;
  }
}
